// extracted by mini-css-extract-plugin
export default {"root":"DistributionControls_root__rGYo8","placeHolderShimmer":"DistributionControls_placeHolderShimmer__7dhdR"};